const predefinedDocumentTypes = [
    {
        id: "bank_check",
        name: "Bank Check",
        description: "A written, dated, and signed instrument that directs a bank to pay a specific sum of money to the bearer or to a specified payee.",
        uniqueWords: ["bank check", "cheque", "payee", "date", "amount", "signature", "account number"]
    },
    {
        id: "bank_statement",
        name: "Bank Statement",
        description: "A report summarizing all transactions in a bank account over a given period, including deposits, withdrawals, and balances.",
        uniqueWords: ["bank statement", "account number", "opening balance", "closing balance", "transaction date", "description", "debit", "credit", "balance"]
    },
    {
        id: "bill_of_lading",
        name: "Bill of Lading",
        description: "A detailed list of goods being shipped, acting as a receipt of shipment when the goods are delivered at the predetermined destination.",
        uniqueWords: ["bill of lading", "shipper", "consignee", "vessel", "port of loading", "port of discharge", "freight", "description of goods"]
    },
    {
        id: "business_card",
        name: "Business Card",
        description: "A small card printed with business information about a company or individual, used for networking and contact sharing.",
        uniqueWords: ["name", "title", "company", "email", "phone", "address", "website", "logo"]
    },
    {
        id: "contract",
        name: "Contract",
        description: "A legally binding agreement between two or more parties, outlining terms, obligations, and rights.",
        uniqueWords: ["contract", "agreement", "terms and conditions", "parties", "effective date", "signature"]
    },
    {
        id: "credit_note",
        name: "Credit Note",
        description: "A document issued by a seller to a buyer, indicating that a credit has been made to the buyer's account due to returns or overpayment.",
        uniqueWords: ["credit note", "credit memo", "credit", "adjustment", "refund", "return", "credit amount"]
    },
    {
        id: "debit_note",
        name: "Debit Note",
        description: "A document issued by a seller to a buyer, indicating that a debit has been made to the buyer's account for an undercharged amount or additional fees.",
        uniqueWords: ["debit note", "debit memo", "debit", "charge", "additional charge", "debit amount"]
    },
    {
        id: "delivery_note",
        name: "Delivery Note",
        description: "A document accompanying a shipment of goods, listing items and quantities delivered, and serving as acknowledgement of receipt.",
        uniqueWords: ["delivery note", "delivery receipt", "shipping note", "packing list", "goods received"]
    },
    {
        id: "email",
        name: "Email",
        description: "An electronic message sent from one user to one or more recipients, often including a subject and optional attachments.",
        uniqueWords: ["subject", "to", "from", "cc", "bcc", "sent", "received", "attachment"]
    },
    {
        id: "invoice",
        name: "Invoice",
        description: "A document issued by a seller to a buyer, indicating the products or services provided, quantities, prices, and payment terms.",
        uniqueWords: ["invoice", "total", "due date", "invoice number", "amount", "payment terms", "tax", "subtotal"]
    },
    {
        id: "purchase_order",
        name: "Purchase Order",
        description: "A buyer-issued document to a seller, authorizing the purchase of specified goods or services at agreed prices and terms.",
        uniqueWords: ["purchase order", "po number", "order date", "delivery date", "terms", "ship to", "bill to"]
    },
    {
        id: "proforma_invoice",
        name: "Proforma Invoice",
        description: "A preliminary bill sent to a buyer in advance of a shipment or delivery, outlining estimated costs and terms.",
        uniqueWords: ["proforma", "pro forma", "estimate", "preliminary", "advance payment", "quote"]
    },
    {
        id: "quotation",
        name: "Quotation",
        description: "A formal statement from a seller to a prospective buyer, offering specific goods or services at stated prices valid for a set period.",
        uniqueWords: ["quotation", "quote", "estimate", "valid until", "terms and conditions", "pricing"]
    },
    {
        id: "receipt",
        name: "Receipt",
        description: "A written acknowledgment that payment has been received for goods or services from a buyer by a seller.",
        uniqueWords: ["receipt", "payment received", "thank you", "date", "total", "cash", "card", "change"]
    },
    {
        id: "resume",
        name: "Resume",
        description: "A document summarizing an individual's work experience, education, skills, and achievements, used for job applications.",
        uniqueWords: ["resume", "curriculum vitae", "education", "experience", "skills", "contact", "summary"]
    }
].sort((a, b) => a.name.localeCompare(b.name)).map((docType) => ({
    ...docType,
    name: docType.name.toLowerCase()
}));

export default predefinedDocumentTypes;
